<!-- 免费发布信息分类页面 -->
<template>
  <div class="container">
      <login-navigator></login-navigator>
      <publish-nav></publish-nav>
      <publish-status :navStatus="navStatus"></publish-status>
      <section class="main">
        <ul>
          <li v-for="(item,index) in category" :key="index"  @click="toPublish($event)">{{item}}</li>
        </ul>
      </section>
      <router-view></router-view>
  </div>
</template>

<script>
import PublishNav from "../../components/PublishNav";
import LoginNavigator from "../../components/LoginNavigator";
import PublishStatus from "../../components/PublishStatus";
export default {
  data() {
    return {
      category: [
        "房产",
        "二手物品",
        "车辆买卖与服务",
        "宠物",
        "交友活动",
        "生活服务",
        " 求职简历",
        "兼职招聘",
        "教育培训",
        "全职招聘"
      ],
      navStatus: 0
    };
  },
  components: {
    PublishNav,
    LoginNavigator,
    PublishStatus
  },
  methods: {
    toPublish: function(event) {
      console.log(event);
      let name = event.target.innerHTML,
        that = this;
      console.log(name);
      switch (name) {
        case "房产":
          that.$router.push({ path: "homePublish" });
          break;
        case "二手物品":
          that.$router.push({ path: "secondhandPublish" });
          break;
        case "车辆买卖与服务":
          that.$router.push({ path: "carPublish" });
          break;
        case "宠物":
          that.$router.push({ path: "petPublish" });
          break;
        case "全职招聘":
          that.$router.push({ path: "recruitPublish" });
          break;
        case "教育培训":
          that.$router.push({ path: "eduPublish" });
          break;
        case "交友活动":
          that.$router.push({ path: "friendPublish" });
          break;
        case "兼职招聘":
          that.$router.push({ path: "partTimePublish" });
          break;
        case "生活服务":
          that.$router.push({ path: "livePublish" });
          break;
        default:
          that.$router.push({ path: "resumePublish" });
          break;
      }
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  background: #f5f5f5;
}
.main {
  width: 1200px;
  height: 940px;
  margin: 0 auto;
  background: #fff;
}
.main ul {
  padding-left: 23px;
}
.main ul li {
  padding-top: 32px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/publish.vue